module.exports = __webpack_public_path__ + "static/media/car-crash-crop.d9174d63.jpg";